import { buildDiagnosticsReport } from "#build-diagnostics-report";
import { markDiagnostics } from "#diagnostics-recorder";

/** Downloads the report as a JSON file (the web analogue of the native share sheet). */
export async function shareDiagnosticsReport(
  options: { userNote?: string | null } = {},
): Promise<{ fileName: string }> {
  markDiagnostics("share-diagnostic-report");
  const report = await buildDiagnosticsReport({ userNote: options.userNote ?? null });
  const fileName = `han-diagnostic-${report.generatedAt.replaceAll(/[:.]/g, "-")}.json`;
  const url = URL.createObjectURL(new Blob([JSON.stringify(report)], { type: "application/json" }));
  const anchor = document.createElement("a");
  anchor.download = fileName;
  anchor.href = url;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
  return { fileName };
}
